import { LocalizedValueInput, SupportedLanguages } from "gql/graphql";
import { useUserSettings } from "@/application/providers/user-settings";
import { useApplicationSettings } from "@/application/providers/application-settings";

export type LocalizedControlName = keyof LocalizedValueInput;

const LANGUAGE_TO_CONTROL_NAME: Record<
  SupportedLanguages,
  LocalizedControlName
> = {
  [SupportedLanguages.En]: "langValueEn",
  [SupportedLanguages.Ru]: "langValueRu",
  [SupportedLanguages.Kz]: "langValueKz",
  [SupportedLanguages.Uz]: "langValueUz",
};

export function useLocalizedFields() {
  const { languages: languageSettings } = useApplicationSettings();

  const languages =
    languageSettings?.length === 0
      ? [
          SupportedLanguages.En,
          SupportedLanguages.Ru,
          SupportedLanguages.Kz,
          SupportedLanguages.Uz,
        ]
      : languageSettings;

  const userSettings = useUserSettings();

  const currentLanguages =
    userSettings.settings?.primaryLanguage ?? SupportedLanguages.En;

  const localeToControlName = (locale: SupportedLanguages) =>
    LANGUAGE_TO_CONTROL_NAME[locale];

  return {
    languages,
    currentLanguages,
    localeToControlName,
  };
}
